import { Handle, Position, useReactFlow } from "@xyflow/react";
import { useState } from "react";
import { Dropdown } from "react-bootstrap";
import { Trash } from "react-bootstrap-icons";
import { useTrashNode } from "./commons/trashNode";
import { FlowHandle } from "./commons/flowHandle";

export default function CustomConnectorNode({
  id,
  data,
}) {
  const [settings, setSettings] = useState();
  const trashNode = useTrashNode();
  const { getNodes, setNodes, getEdges, setEdges } = useReactFlow();

  return (
    <dl className="mt-3" style={{ width: "290px" }}>
      <FlowHandle type="target" id={`target-${id}`} position={Position.Left} />
      <FlowHandle type="source" id={`source-${id}`} position={Position.Right} />
      <div className="card shadow-sm border">
        {/* Header */}
        <div className="card-header d-flex justify-content-between align-items-center py-2 bg-light border-bottom">
          <h6 className="mb-0 fw-semibold text-primary">Connector</h6>
          <button
            onClick={(e) => trashNode(e, id)}
            className="btn btn-sm btn-light text-danger p-1"
            title="Delete Connector"
            aria-label="Delete Connector"
          >
            <Trash size={16} />
          </button>
        </div>

        {/* Body */}
        {!settings?.appName ? (
          <div className="card-body text-center p-4">
            <p className="text-muted mb-3 small">
              Your app is not connected.
            </p>
            <button
              type="button"
              className="btn btn-sm btn-outline-primary"
            >
              Connect Now
            </button>
          </div>
        ) : (
          <div className="card-body p-3">
            {/* App name */}
            <h6 className="text-muted mb-2 small">
              {settings.appName}:
            </h6>

            {/* App Action Input */}
            <div>
              <input
                type="text"
                value={settings.appActionName}
                onChange={(e) =>
                  setSettings({ ...settings, appActionName: e.target.value })
                }
                placeholder="Enter app action"
                className="form-control form-control-sm"
              />
            </div>
          </div>
        )}
      </div>
    </dl>
  );
}
